export default __webpack_public_path__ + "static/boring-company-384162b6bb0e92af3096af1b6672df25.svg";